import React from "react";
import type { SxProps, Theme } from "@mui/material";
import { Box, Typography } from "@mui/material";

export interface InfoFieldProps {
  label: string;
  value: React.ReactNode;
  spacing?: number;
  labelSx?: SxProps<Theme>;
}

// Exported for the few details-page headings that aren't a field but must line up with one.
export const detailFieldLabelSx = {
  textTransform: "uppercase",
  fontWeight: 600,
  letterSpacing: 0.5,
} as const;

export function DetailField({ label, value }: Pick<InfoFieldProps, "label" | "value">) {
  return <InfoField label={label} value={value} spacing={0} labelSx={detailFieldLabelSx} />;
}

export function InfoField({ label, value, spacing = 2, labelSx }: InfoFieldProps) {
  return (
    <Box sx={{ mb: spacing }}>
      <Typography
        variant="body2"
        sx={[{ color: "text.secondary", mb: 0.5 }, ...(Array.isArray(labelSx) ? labelSx : [labelSx])]}
      >
        {label}
      </Typography>
      <Typography variant="body1" component="div">
        {value}
      </Typography>
    </Box>
  );
}
